export default {"src":"/_next/static/media/feature_4.9d34e63d.svg","height":92,"width":94,"blurWidth":0,"blurHeight":0};